import styled from "styled-components";
import { borderRadius, spacing } from "@magicbi/ui-library";
import type { StackedMeterTone } from "./StackedMeter.types";

export const Track = styled.span`
  display: flex;
  gap: ${spacing[0.5]};
  width: 7rem;
  max-width: 100%;
  height: 0.375rem;
  margin-top: ${spacing[1]};
`;

export const Part = styled.i<{ $tone: StackedMeterTone; $grow: number }>`
  display: block;
  flex: ${({ $grow }) => $grow};
  min-width: 0.25rem;
  height: 100%;
  border-radius: ${borderRadius.xs};
  background: ${({ theme, $tone }) =>
    $tone === "success"
      ? theme.colors.success[500]
      : $tone === "error"
        ? theme.colors.error[500]
        : $tone === "warning"
          ? theme.colors.warning[500]
          : $tone === "live"
            ? theme.colors.interactive.primary
            : theme.colors.border.stroke};
`;
